import EmailSignup from './EmailSignup'

export default EmailSignup